import React from 'react';
import PropTypes from 'prop-types';
import { formatAmount } from '../../utilsV3/amountUtils';
import Currency from './Currency';
import AmountType from '../../shared/amountSetup/AmountType';

function AmountSetup({ application, formValues, change }) {
  const { receivableCurrency } = application;

  const getValue = (key) => {
    return formValues[key];
  };

  const amountType = getValue('amountType');

  const handleAmountFormatChange = (currency) => {
    if (getValue('amountValue')) {
      const value = getValue('amountValue');
      const formattedAmount = formatAmount(value);
      change('amountValue', formattedAmount);
    }

    if (
      getValue('merchantAmount1') ||
      getValue('merchantAmount2') ||
      getValue('merchantAmount3')
    ) {
      const merchantAmount1 = getValue('merchantAmount1');
      const formattedAmount1 = formatAmount(merchantAmount1);
      change('merchantAmount1', formattedAmount1);

      const merchantAmount2 = getValue('merchantAmount2');
      const formattedAmount2 = formatAmount(merchantAmount2);
      change('merchantAmount2', formattedAmount2);

      const merchantAmount3 = getValue('merchantAmount3');
      const formattedAmount3 = formatAmount(merchantAmount3);
      change('merchantAmount3', formattedAmount3);
    }
  };

  const handleAmountTypeChange = () => {
    change('amountValue', '');
    change('merchantAmount1', '');
    change('merchantAmount2', '');
    change('merchantAmount3', '');
  };

  return (
    <div className="amount-setup">
      <Currency
        receivableCurrency={receivableCurrency}
        handleAmountFormatChange={handleAmountFormatChange}
      />
      <AmountType
        amountType={amountType}
        handleAmountTypeChange={handleAmountTypeChange}
        receiverCurrency={getValue('receiverCurrency')}
      />
    </div>
  );
}

AmountSetup.propTypes = {
  application: PropTypes.object,
  formValues: PropTypes.object,
  change: PropTypes.func,
};

export default AmountSetup;
